import { useEffect, useState } from 'react';

/** True while the browser reports a network connection. */
export function useOnline(): boolean {
    const [online, setOnline] = useState(() => navigator.onLine);
    useEffect(() => {
        const goOnline = (): void => {
            setOnline(true);
        };
        const goOffline = (): void => {
            setOnline(false);
        };
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        return () => {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);
    return online;
}
